// RichTextEditor.tsx
import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { styled } from "@mui/material/styles";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import clsx from "clsx";

const Root = styled("div")({
  "& .rdw-dropdown-selectedtext": {
    color: "inherit",
  },
  "& .rdw-editor-toolbar": {
    borderWidth: "0 0 1px 0!important",
    margin: "0!important",
  },
  "& .rdw-editor-main": {
    padding: "8px 12px",
    height: `${256}px!important`,
  },
});

interface RichTextEditorProps {
  value?: string; // Initial HTML content
  onChange: (value: string) => void;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ value, onChange }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (value) {
      const contentBlock = htmlToDraft(value);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }
    }
  }, [value]);

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
    const rawContentState = convertToRaw(state.getCurrentContent());
    const htmlContent = draftToHtml(rawContentState);
    onChange(htmlContent);
  };

  return (
    <Root className={clsx("rounded-4 border-1 overflow-hidden w-full")}>
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={handleEditorChange}
      />
    </Root>
  );
};

export default RichTextEditor;
